import { render, staticRenderFns } from "./DomainResultsList.vue?vue&type=template&id=5f0e5504"
import script from "./DomainResultsList.vue?vue&type=script&lang=js"
export * from "./DomainResultsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports